/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import Vue from 'vue';
import App from './App.vue';

import 'vuesax/dist/vuesax.css'; // Vuesax

// Theme Configurations
import '../themeConfig.js';

//Add extension
import './common/prototype';

// Globally Registered Components
import './globalComponents.js';

// keycode
import './keycodes.js';

// Globally Registered Components
import './globalPlugin.js';

// Tailwind
import '@/assets/css/main.css';

// Vue Router
import router from './router';

// Vuex Store
import store from './store/store';

// i18n
import i18n from './i18n/i18n';

import './filters/filters';

import vi from '@/i18n/vi/i18nValidate';

// // PrismJS
import 'prismjs';
import 'prismjs/themes/prism-tomorrow.css';

// Feather font icon
require('./assets/css/iconfont.css');
require('./assets/css/icon.css');
require('./assets/css/process.css');

// Styles: SCSS
import './assets/scss/main.scss';

// Styles: SCSS
import '@/assets/scss/common/main.scss';
import '@/assets/scss/common/common_default.scss';

import VueDraggable from 'vuedraggable';
Vue.use(VueDraggable);

import VTooltip from '@/components/msTooltip';
Vue.use(VTooltip);

import browserDetect from 'vue-browser-detect-plugin';
Vue.use(browserDetect);

Vue.config.productionTip = false;

// Vue.config.errorHandler = log.handleGlobalException;
if (process.env.NODE_ENV == 'development') {
	Vue.config.performance = true;
}

//Kiểm tra phiên bản và trình duyệt
let appVer = window.navigator.userAgent;
if (
	appVer.indexOf('Edge/') > -1 || //edge
	appVer.indexOf('.NET') > -1 || //ie
	(appVer.indexOf('Safari/') > -1 &&
		appVer.indexOf('Version/') > -1 &&
		appVer.indexOf('OPR/') == -1)
) {
	//Ứng dụng không hỗ trợ những trình duyệt này, nên không tạo instance của VueJs
} else {
	new Vue({
		router,
		store,
		i18n,
		render: h => h(App)
	}).$mount('#app');
}
